import { useCallback, useEffect, useState } from "react";
import classNames from "classnames";
import Image from "next/image";

import { MoreIcon } from "../../AscIcons";
import styles from "./AscResourceSkillCard.module.scss";
import cardImage from "../../../assets/images/resources-skill-card.png";
import AscAdminAction from "../../AscAdminAction/AscAdminAction";
import AscGenericCard from "../AscGenericCard/AscGenericCard";
import { useOutsideClick } from "@ascendnow/shared";

export interface AscResourceSkillCard {
  card: any;
  className?: string;
  loading?: boolean;
  onEdit?: () => void;
  onRemove?: () => void;
  onShowMore?: () => void;
}

export default function AscResourceSkillCard({
  card,
  className,
  loading = false,
  onEdit,
  onRemove,
  onShowMore,
}: AscResourceSkillCard) {
  const {
    ref: moreIconRef,
    setIsVisible: setShowAction,
    isVisible: showAction,
  } = useOutsideClick<HTMLDivElement>(false);
  const [modulesCount, setModulesCount] = useState<number>();

  const handleMoreAction = () => {
    setShowAction(!showAction);
  };

  useEffect(() => {
    let _moduleCount = 0;
    card.skills.map((skill: any) => (_moduleCount += skill.modulesNum));
    setModulesCount(_moduleCount);
  }, []);

  const handleShowMore = useCallback(() => {
    setShowAction(false);
    onShowMore?.();
  }, [card, onShowMore]);

  const handleEdit = () => {
    setShowAction(false);
    onEdit?.();
  };
  const handleRemove = () => {
    setShowAction(false);
    onRemove?.();
  };
  return (
    <AscGenericCard
      className={classNames(
        styles.ground,
        {
          [styles.loading]: loading,
        },
        className
      )}
      loading={loading}
      titleClassName={styles.cardTitle}
      bodyClassName={styles.cardBody}
      contentClassName={styles.cardContent}
      title={card.name}
      customImage={
        <div className={styles.topContent}>
          <Image
            src={cardImage}
            alt="resource-skill-image"
            className={styles.image}
          />
        </div>
      }
    >
      <div className={styles.textContainer}>
        <span
          className={styles.text}
        >{`${card.skills.length} Skills | ${modulesCount} Modules`}</span>
      </div>
      <div ref={moreIconRef} className={styles.btnMoreWrapper}>
        <MoreIcon
          className={styles.moreIcon}
          data-testid={"asc-skill-card-more-icon"}
          onClick={handleMoreAction}
        />
        {showAction && (
          <AscAdminAction
            option1={"Edit"}
            option2={"Delete"}
            option3={"Show Skill info"}
            clickOption1={handleEdit}
            clickOption2={handleRemove}
            clickOption3={handleShowMore}
            className={styles.adminAction}
          />
        )}
      </div>
    </AscGenericCard>
  );
}
